import log  from './log'
import slice from 'lodash/slice'
import toArray from 'lodash/toArray'
import throttle from 'lodash/throttle'

import {form as uform} from './form'
import * as uurl from './url'
import bowser from 'bowser/es5'

import {on as uon, trigger as utrigger} from './event'

const browser = bowser.getParser(window.navigator.userAgent);
const ua = browser.parse();

const currentModule = {};

// TODO система событий

  let $module = $(currentModule),
      $body                     = $('body'),
      $document = $(window.document),
      typeUpdateForm            = '',

      urlHashChangeEventName = 'change.kiosk.urlHash',

      scrollDocument = function() {
        trigger("document:scroll", $document.scrollTop());
      },
      scrollFastDocument = function() {
        trigger("document:scroll:fast", $document.scrollTop());

      },
      leavePage = function() {
        trigger('document:leave');
      },
      trigger = function(name, data) {
        // trigger with param[]
        $module.trigger(name, [data]);
      },
      on = function (name, fn) {
        $module.on(name, function(event){
          const params = slice(toArray(arguments), 1);
          fn.apply(undefined, params);
        });
      },
      off = function(name, fn) {
        $module.off(name, fn);
      }

  ;


  // $('form[data-immediately-save="1"]').on('date-change:change', function(e, name, value){
  //     console.log(e, name, value);
  //     saveSingleFormElementData($(e.target), name, value);
  // });

  $body.on('change', 'form[data-immediately-save="1"]', function(e) {
    uform.saveSingleFormElementData($(e.target).parents('form'), e.target.name, e.target.value);
  });

  $('.mobile-menu-items-wrapper').on('focus', '.search-input', function(event) {
    var $menu = $('.mobile-menu');
    $menu.scrollTop($menu.find('.mobile-menu-items-wrapper').height());
  });

  uon(urlHashChangeEventName, function(e) {
    var eventData = e.detail,
        hash = eventData.hash;

    if (hash && hash !== undefined) {
      uurl.setHash(hash);
    } else {
      uurl.removeHash();
    }
  });

  $(window).on({
    // resize: utils.debounce(utils.bind(resizeWindow, this), 30),
    // popstate: utils.bind(changeUrl, this)
  });
  $document.on({
    // keydown: utils.bind(keydownDocument, this),
    // keyup: utils.bind(keyupDocument, this),
    // scroll: utils.throttle(i.bind(this.scrollDocument, this), 300)
    scroll: throttle(scrollDocument, 300),
    "pjax:end": leavePage
  });

  // $document.on("scroll", utils.throttle(scrollFastDocument, 50));
  $document.on("scroll", scrollFastDocument);

  window.addEventListener('beforeunload', leavePage);

  // $document.on(ua.device.family === "iPhone" ? "pagehide" : "beforeunload", function(){leavePage()});

  // var changeParamsEventName = 'change.kiosk.urlParams';

  // KIOSK.on(changeUrlQueryParams, function (e) {
  //     var data = e.data;
  //     alert(data);
  //
  // });

  // on change user interseting - change menu items
  // on change subscriob - chaneg all interfaces


// console.log(ua.parsedResult)


  const main = {
    urlHashChangeEventName: urlHashChangeEventName,
    // changeEventName: changeEventName
    ua: ua.parsedResult,
    isMobile: ua.parsedResult.platform.type === 'mobile',
    trigger: trigger,
    on: on,
    off: off

    // ,configGet: new config("GET")
  };


  export default main;